// This is the javascript entrypoint for the image-element snippet.
// This file and all its inclusions will be processed through esbuild

import '@archetype-themes/scripts/config';
import '@archetype-themes/scripts/helpers/sections';

/*============================================================================
  AtIcon
==============================================================================*/

// ABSCENTS v108: cada SVG se pide una sola vez por página (antes cada icono hacía su propia
// petición: en el inicio eran ~130 peticiones para 8 iconos distintos).
const abxIconos = new Map();

function abxIcono(src) {
  if (!abxIconos.has(src)) {
    abxIconos.set(src, fetch(src)
      .then(response => {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .catch(error => {
        abxIconos.delete(src);
        throw error;
      }));
  }
  return abxIconos.get(src);
}

class AtIcon extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // ABSCENTS: leer atributos aquí (y no en el constructor) para que los
    // iconos clonados con cloneNode (footer -> menú móvil) también carguen.
    this.src = this.getAttribute('src');
    this.name = this.getAttribute('data-name');
    if (!this.src) return;
    if (this.querySelector('svg')) return;

    abxIcono(this.src)
      .then(svg => {
        this.innerHTML = svg;
        const icono = this.querySelector('svg');
        if (icono) icono.classList.add('icon', `icon-${this.name}`);
      }).catch(error => {
        console.log('Error:', error);
      });
  }
}

customElements.define('at-icon', AtIcon);
